import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getSectorCategories, getSectorFamilies, getSectorProducts, getSectorSegments } from '../../services/sectors'

const SERVICES_DICTIONARY = {
  categories: getSectorCategories,
  families: getSectorFamilies,
  products: getSectorProducts,
  segments: getSectorSegments
}

const TYPES_DICTIONARY = {
  categories: 'categories',
  families: 'families',
  products: 'products',
  segments: 'segments'
}

const KEYS_DICTIONARY = {
  categories: {
    amount: 'amountCategory',
    amountUSD: 'amountCategoryUSD',
    label: 'category',
    name: 'idCategory',
    type: 'categories'
  },
  families: {
    amount: 'amountFamily',
    amountUSD: 'amountFamilyUSD',
    label: 'family',
    name: 'idFamily',
    type: 'families'
  },
  products: {
    amount: 'amountProduct',
    amountUSD: 'amountProductUSD',
    label: 'product',
    name: 'idProduct',
    type: 'products'
  },
  segments: {
    amount: 'amountSegment',
    amountUSD: 'amountSegmentUSD',
    label: 'segment',
    name: 'idSegment',
    type: 'segments'
  }
}

export const GET_SECTOR_ITEMS_AND_PRODUCTS = 'GET_SECTOR_ITEMS_AND_PRODUCTS'
export const GET_SECTOR_ITEMS_AND_PRODUCTS_ERROR = 'GET_SECTOR_ITEMS_AND_PRODUCTS_ERROR'
export const GET_SECTOR_ITEMS_AND_PRODUCTS_SUCCESS = 'GET_SECTOR_ITEMS_AND_PRODUCTS_SUCCESS'
export const onGetSectorItemsAndProducts = makeActionCreator(GET_SECTOR_ITEMS_AND_PRODUCTS)
export const onGetSectorItemsAndProductsError = makeActionCreator(GET_SECTOR_ITEMS_AND_PRODUCTS_ERROR, 'payload')
export const onGetSectorItemsAndProductsSuccess = makeActionCreator(GET_SECTOR_ITEMS_AND_PRODUCTS_SUCCESS, 'payload')
export const onGetSectorItemsAndProductsThunk = payload => async dispatch => {
  dispatch(onGetSectorItemsAndProducts())

  try {
    const { data = {} } = await SERVICES_DICTIONARY[payload.type]({
      actionType: GET_SECTOR_ITEMS_AND_PRODUCTS,
      categoryId: payload.categoryId,
      familyId: payload.familyId,
      sectorId: payload.id,
      productId: payload.productId,
      segmentId: payload.segmentId,
      year: payload.year
    })
    const { data: collection = [] } = data.payload.find(item => item.year === payload.year)
    const enhancedData = collection
      .map(item => {
        return {
          amount: item[KEYS_DICTIONARY[payload.type].amount],
          amountUSD: item[KEYS_DICTIONARY[payload.type].amountUSD],
          categoryId: item.idCategory !== 0 ? item.idCategory : undefined,
          familyId: item.idFamily !== 0 ? item.idFamily : undefined,
          label: item[KEYS_DICTIONARY[payload.type].label],
          name: item[KEYS_DICTIONARY[payload.type].name],
          productId: item.idProduct !== 0 ? item.idProduct : undefined,
          segmentId: item.idSegment !== 0 ? item.idSegment : undefined,
          type: TYPES_DICTIONARY[payload.type]
        }
      })
      .sort((item1, item2) => item2.amount - item1.amount)
      .map((item, index, items) => ({
        ...item,
        index,
        drilldown: item.type !== TYPES_DICTIONARY.products,
        parent: item.type === TYPES_DICTIONARY.segments ? items.length - index : index + 1
      }))
    const csv =
      [
        ['Nombre rubro', 'Monto total (CLP)', 'Monto total (USD)'],
        ...enhancedData?.map(item => [item.label, item.amount, item.amountUSD])
      ] || []

    return batch(() => {
      payload.callback && payload.callback()
      dispatch(onGetSectorItemsAndProductsSuccess({ ...payload, csv, data: enhancedData }))
    })
  } catch (error) {
    return dispatch(onGetSectorItemsAndProductsError({ error }))
  }
}
